import { useSelector } from "react-redux";
import TableHeaderCell from "../../common/table/tableHeaderCell";
import { t } from "i18next";
import { useParams } from "react-router-dom";
import { useAppDispatch } from "../../../redux";
import { onClickOrder } from "../../../utils/helpers";
import {
  getSurveyHistory,
  updateOrder,
  updateOrderAs,
  updatePage,
} from "../../../redux/reducer/surveyHistoryReducer";

const TableHeader = () => {
  const dispatch = useAppDispatch();

  /**
   * Get url params.
   */
  const { id } = useParams();

  const { surveysHistory } = useSelector((state: any) => state);
  const { order, orderAs } = surveysHistory;

  const OnClickOrder = async (orderType: string) => {
    const { orderOption, listOrderAs } = onClickOrder(
      order,
      orderAs,
      orderType
    );
    dispatch(updateOrder(orderOption));
    dispatch(updateOrderAs(listOrderAs));
    dispatch(updatePage(1));
    dispatch(getSurveyHistory(id));
  };

  const getIcon = (orderType: String) => {
    let icon = "unfold_more";

    if (order === orderType) {
      if (orderAs === "desc") {
        icon = "keyboard_arrow_up";
      } else {
        icon = "keyboard_arrow_down";
      }
    }
    return icon;
  };

  return (
    <thead>
      <tr>
        <TableHeaderCell
          icon={getIcon("campaign")}
          onClickOrder={() => {
            OnClickOrder("campaign");
          }}
          className="regionalCodeWidth"
          label={t("campaign")}
        />
        <TableHeaderCell
          icon={getIcon("name")}
          onClickOrder={() => {
            OnClickOrder("name");
          }}
          label={t("headerSection.question")}
        />
        <TableHeaderCell
          icon={getIcon("createdOn")}
          onClickOrder={() => {
            OnClickOrder("createdOn");
          }}
          label={t("date")}
        />
         <TableHeaderCell
          icon={getIcon("data_somministrazione")}
          onClickOrder={() => {
            OnClickOrder("data_somministrazione");
          }}
          label={t("data-somministrazione")}
        />

        <TableHeaderCell />
      </tr>
    </thead>
  );
};

export default TableHeader;
